<template>
  <div :class="$style.wrapper" tabindex="0" role="button" @click="emitClick">
    <IconSelect :class="$style.icon" icon="backlink" :icon-props="{ 'stroke-width': 1 }" />

    <span class="pa-0 ma-0">
      {{ text }}
    </span>
  </div>
</template>

<script>
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'BackButton',
  components: {
    IconSelect,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  display: inline-flex;
  align-items: center;

  color: var(--primary);

  outline: none !important;

  &:hover {
    .icon {
      transform: scale(1.2);
    }
  }
}

.icon {
  margin-right: 0.35rem;

  transition: transform var(--transition-primary);
}
</style>
